import { Table, type TableTrProps } from "@mantine/core";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
} & TableTrProps;

export function TableTr({ children, ...tableProps }: Props) {
  const defaultOption: Omit<TableTrProps, "children"> = {};
  const option = Object.assign({}, defaultOption, tableProps);
  return <Table.Tr {...option}>{children}</Table.Tr>;
}
